import { render, staticRenderFns } from "./ModalExamFilter.vue?vue&type=template&id=6c4f9e42&scoped=true&"
import script from "./ModalExamFilter.vue?vue&type=script&lang=ts&"
export * from "./ModalExamFilter.vue?vue&type=script&lang=ts&"
import style0 from "./ModalExamFilter.vue?vue&type=style&index=0&id=6c4f9e42&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4f9e42",
  null
  
)

export default component.exports